export const TOAST_OPTIONS = {
  duration: 3000,
};
